<template>
	<button class="global-currency-select" :class="{ 'global-currency-select--compact': compact }" aria-label="Wybierz walutę">
		<ClientOnly>
			<template #fallback>
				<div class="global-currency-select__activator">
					<div class="global-currency-select__currency">
						{{ useCookie('currency') }}
					</div>
					<GlobalIcon name="arrow-down" :height="compact ? 12 : 16" class="global-currency-select__select-icon" />
				</div>
			</template>
			<v-menu attach class="global-currency-select__menu" scroll-strategy="close">
				<template #activator="{ props }">
					<div class="global-currency-select__activator" role="button" v-bind="props">
						<template v-if="!loading">
							<div class="global-currency-select__currency">
								{{ selectedCurrency }}
							</div>
							<GlobalIcon name="arrow-down" :height="compact ? 12 : 16" class="global-currency-select__select-icon" />
						</template>
						<template v-else>
							<v-progress-circular aria-label="loading" :size="compact ? 16 : 24" :width="3" color="var(--primary-color)" />
							<GlobalIcon name="arrow-down" :height="compact ? 12 : 16" class="global-currency-select__select-icon" />
						</template>
					</div>
				</template>
				<LazyCurrencySelectList :currencies="availableCurrencies" @select="changeCurrency" />
			</v-menu>
		</ClientOnly>
	</button>
</template>

<script setup lang="ts">
defineProps<{
	compact?: boolean
}>()

const selectedCurrency = ref('PLN')
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const availableCurrencies = availableCurrenciesArray

const assignCurrencyOnStart = () => {
	const currency = useCookie('currency').value
	if (currency) {
		selectedCurrency.value = currency
	}
}
onMounted(() => {
	if (route.query.refreshed) {
		// delete query params
		router.replace({
			path: route.path,
			query: {},
		})
	}
	assignCurrencyOnStart()
})

const changeCurrency = (currency: string) => {
	selectedCurrency.value = currency
	setCurrency(currency)
}

const setCurrency = (currency: string) => {
	useCookie('currency').value = currency
	// router.go(0)
	// window.location.reload(true)
	loading.value = true
	window.location.href = `${window.location.pathname}?refreshed=${Date.now()}`
}
</script>

<style lang="scss" scoped src="./Select.scss"></style>
